<!-- <p>choose-color works!</p> -->
<div class="color_container_outer" *ngIf="dataColor.length>1">
	<h3>Choose Variant</h3>
	<div class="color_container">
		<ng-container *ngFor="let color of dataColor; let i = index">
			<ng-container *ngIf="i<5">
				<a href="product/{{fabricOrFinished}}/{{color.slug}}" target="_blank">
					<button class="{{deltaIndex==i?'active':''}}"
						(click)="selectFinishOption(i)">

						<img src="{{color.heroImage}}" alt="{{color.name}}"/>
					</button>
				</a>
			</ng-container>
		</ng-container>

		<span class="viewMore_container" *ngIf="moreColor.length>0">
			<div class="view_more_inner">

				<button class="trigger_more"><span>+</span>{{moreColor.length}}</button>

				<div class="view_more_popup_wrapper">
					<div class="view_more_popup craft_wrapper">
						<ng-container *ngFor="let color of moreColor; let o = index">
							<a href="product/{{fabricOrFinished}}/{{color.slug}}" target="_blank">
								<button (click)="selectFinishOption(o)">
									<img src="{{color.heroImage}}" alt="{{color.name}}"/>
								</button>
							</a>
						</ng-container>
					</div>
				</div>
			</div>
		</span>
	</div>
</div>
